import React from "react";
import { RootWrapper, ContentWrapper } from "./TabPanel.styles";

const TabPanel = ({ children, value, index, selectedValue }) => {
  return (
    <RootWrapper
      role="tabpanel"
      hidden={value !== selectedValue}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === selectedValue && <ContentWrapper>{children}</ContentWrapper>}
    </RootWrapper>
  );
};

export default TabPanel;
